import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import image3 from '../assets/image-carousel-3.jpg'

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: 'What types of crew members do you provide?',
      answer: 'We provide a comprehensive range of maritime professionals including deck officers, engineers, technicians, support staff, and specialized crew members for various offshore operations. All our crew members are qualified, certified, and experienced in their respective roles.'
    },
    {
      question: 'How do you ensure the quality and qualifications of your crew?',
      answer: 'We maintain a rigorous screening and verification process. All crew members undergo thorough background checks, credential verification, skills assessment, and certification validation. We ensure all qualifications meet international maritime standards and regulations before deployment.'
    },
    {
      question: 'What certifications do your crew members hold?',
      answer: 'Our crew members hold various certifications including STCW (Standards of Training, Certification and Watchkeeping), safety certifications, technical qualifications, and other industry-specific credentials required for offshore operations. We ensure all certifications are current and valid.'
    },
    {
      question: 'How long does the recruitment process take?',
      answer: 'The recruitment timeline depends on your specific requirements and the availability of suitable candidates. Typically, we can provide qualified crew members within 2-4 weeks. For urgent requirements, we can expedite the process while maintaining our quality standards.'
    },
    {
      question: 'Do you provide crew management services?',
      answer: 'Yes, we offer comprehensive crew management services including scheduling, rotation management, payroll processing, documentation, compliance monitoring, and ongoing support. Our management services ensure seamless operations and regulatory compliance.'
    },
    {
      question: 'What regions do you serve?',
      answer: 'We provide services globally, with operations spanning across major maritime regions including the North Sea, Gulf of Mexico, Southeast Asia, West Africa, Middle East, and other key offshore operation areas worldwide.'
    },
    {
      question: 'How do you handle crew rotations?',
      answer: 'We manage crew rotations efficiently, ensuring smooth transitions and minimal operational disruption. Our system coordinates scheduling, travel arrangements, documentation, and handover procedures to ensure continuity of operations.'
    },
    {
      question: 'What safety protocols do you follow?',
      answer: 'Safety is our top priority. We adhere to international maritime safety standards including SOLAS, MARPOL, and other relevant regulations. All crew members undergo regular safety training, and we maintain strict compliance with safety protocols and emergency procedures.'
    },
    {
      question: 'Can you provide training for crew members?',
      answer: 'Yes, we offer comprehensive training programs including safety training, technical skills development, certification renewal, and compliance training. We ensure all crew members are up-to-date with the latest industry standards and best practices.'
    },
    {
      question: 'What support do you provide after crew deployment?',
      answer: 'We provide 24/7 support services including emergency response, operational assistance, crew management support, and client consultation. Our support team is always available to address any concerns or requirements you may have.'
    },
    {
      question: 'How do you ensure compliance with international regulations?',
      answer: 'We maintain strict compliance with all international maritime regulations including IMO standards, flag state requirements, and port state control regulations. Our compliance team ensures all documentation, certifications, and procedures meet regulatory requirements.'
    },
    {
      question: 'What are your payment terms?',
      answer: 'Payment terms are flexible and can be customized based on your requirements. We typically work with standard industry payment terms and can discuss specific arrangements that suit your operational needs and budget.'
    }
  ];

  const faqStyles = {
    container: {
      width: '100%',
      position: 'relative',
    },
    // Hero Section
    heroSection: {
      position: 'relative',
      padding: '150px 20px 100px',
      color: '#fff',
      textAlign: 'center',
      backgroundImage: `url(${image3})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '600px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: 1,
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 67, 95, 0.7)',
      zIndex: 1,
    },
    heroContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 2,
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
      color: '#fff',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.8',
      opacity: 0.95,
      maxWidth: '800px',
      margin: '0 auto',
      color: '#fff',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    // FAQ Section
    faqSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    faqContainer: {
      maxWidth: '1000px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
      textAlign: 'center',
    },
    sectionSubtitle: {
      fontSize: '1.2rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '50px',
      textAlign: 'center',
      maxWidth: '800px',
      margin: '0 auto 50px',
    },
    faqList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    faqItem: {
      backgroundColor: '#f8f9fa',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: '0 3px 10px rgba(0, 0, 0, 0.1)',
      transition: 'box-shadow 0.3s ease',
    },
    faqItemHover: {
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.15)',
    },
    faqQuestion: {
      padding: '25px 30px',
      backgroundColor: '#fff',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'background-color 0.3s ease',
      borderBottom: '2px solid transparent',
    },
    faqQuestionHover: {
      backgroundColor: '#f0f0f0',
      borderBottom: '2px solid var(--color-secondary)',
    },
    faqQuestionText: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      fontFamily: 'Poppins, sans-serif',
      flex: 1,
      marginRight: '20px',
    },
    faqIcon: {
      fontSize: '1.5rem',
      color: 'var(--color-secondary)',
      transition: 'transform 0.3s ease',
      flexShrink: 0,
    },
    faqIconOpen: {
      transform: 'rotate(180deg)',
    },
    faqAnswer: {
      padding: '0 30px',
      maxHeight: 0,
      overflow: 'hidden',
      transition: 'max-height 0.3s ease, padding 0.3s ease',
      backgroundColor: '#f8f9fa',
    },
    faqAnswerOpen: {
      maxHeight: '500px',
      padding: '25px 30px',
    },
    faqAnswerText: {
      fontSize: '1.05rem',
      color: '#666',
      lineHeight: '1.8',
      margin: 0,
    },
    // Contact Section
    contactSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    contactContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      textAlign: 'center',
    },
    contactTitle: {
      fontSize: '2rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    contactText: {
      fontSize: '1.1rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '30px',
    },
    contactButton: {
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
    // CTA Section
    ctaSection: {
      padding: '80px 20px',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      textAlign: 'center',
    },
    ctaContainer: {
      maxWidth: '800px',
      margin: '0 auto',
    },
    ctaTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '20px',
      color: '#fff',
    },
    ctaDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      marginBottom: '40px',
      opacity: 0.95,
    },
    ctaButton: {
      backgroundColor: '#fff',
      color: 'var(--color-secondary)',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
  };

  return (
    <div style={faqStyles.container}>
      {/* Hero Section */}
      <section style={faqStyles.heroSection} data-aos="fade-down">
        <div style={faqStyles.heroOverlay}></div>
        <div style={faqStyles.heroContainer}>
          <h1 style={faqStyles.heroTitle}>Frequently Asked Questions</h1>
          <p style={faqStyles.heroSubtitle}>
            Find answers to common questions about our offshore crew manning services, 
            processes, and how we can support your maritime operations.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={faqStyles.faqSection} data-aos="fade-up">
        <div style={faqStyles.faqContainer}>
          <h2 style={faqStyles.sectionTitle}>Common Questions</h2>
          <p style={faqStyles.sectionSubtitle}>
            Browse through our frequently asked questions to learn more about our services, 
            processes, and how we can assist with your offshore crew manning needs.
          </p>
          <div style={faqStyles.faqList}>
            {faqData.map((faq, index) => (
              <div
                key={index}
                style={faqStyles.faqItem}
                data-aos="fade-up"
                data-aos-delay={index * 50}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, faqStyles.faqItemHover);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 3px 10px rgba(0, 0, 0, 0.1)';
                }}
              >
                <div
                  style={faqStyles.faqQuestion}
                  onClick={() => toggleFAQ(index)}
                  onMouseEnter={(e) => {
                    Object.assign(e.currentTarget.style, faqStyles.faqQuestionHover);
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#fff';
                    e.currentTarget.style.borderBottom = '2px solid transparent';
                  }}
                >
                  <div style={faqStyles.faqQuestionText}>{faq.question}</div>
                  <div
                    style={{
                      ...faqStyles.faqIcon,
                      ...(openIndex === index ? faqStyles.faqIconOpen : {}),
                    }}
                  >
                    ▼
                  </div>
                </div>
                <div
                  style={{
                    ...faqStyles.faqAnswer,
                    ...(openIndex === index ? faqStyles.faqAnswerOpen : {}),
                  }}
                >
                  <p style={faqStyles.faqAnswerText}>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section style={faqStyles.contactSection} data-aos="fade-up">
        <div style={faqStyles.contactContainer}>
          <h2 style={faqStyles.contactTitle}>Still Have Questions?</h2>
          <p style={faqStyles.contactText}>
            If you couldn't find the answer you're looking for, our team is here to help. 
            Contact us and we'll get back to you as soon as possible.
          </p>
          <Link
            to="/contact"
            style={faqStyles.contactButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Contact Us
          </Link>
        </div>
      </section>

      {/* CTA Section */}
      <section style={faqStyles.ctaSection} data-aos="fade-up">
        <div style={faqStyles.ctaContainer}>
          <h2 style={faqStyles.ctaTitle}>Ready to Get Started?</h2>
          <p style={faqStyles.ctaDescription}>
            Let us help you find the right crew for your offshore operations. Get in touch 
            with us today to discuss your requirements and discover how we can support your 
            maritime projects.
          </p>
          <Link
            to="/contact"
            style={faqStyles.ctaButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Get In Touch
          </Link>
        </div>
      </section>
    </div>
  )
}

export default FAQ